import {IStateAutoProject} from './CreateAutoProject.types';

export const initializeState:IStateAutoProject = {
    projectId: null,
    projectName: '',
    className: '',
    emails: [],
    projectDescription: '',
    isProjectInitialized: false,
    showProjectNameError: false,
    nameExistError: '',
    uploadClassError: '',
    files: [],
    classError: '',
    projectNameInit: '',
    projectDescriptionInit: '',
    activeAddClass: -1,
    closeEditClass: false,
    activeEditId: -1,
    minReference: 20,
    classMainError: '',
    classFiles: [],
    tags: [],
    classes: [],
    labels: [],
    attributes: [],
    isRandomBtn: true,
    filesDict: {},
    openCreateProjectModal: false,
};

export const initializeStateJson = JSON.stringify(initializeState);
